import { fetchRequest } from "@providers/conect";

const buscarMiembrosWpApi = async (data) => {
  try {
    const url = `userswp/miembros/buscar`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: data,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const listarNivelesMiembrosWpApi = async () => {
  try {
    const url = `userswp/miembros/niveles`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: {},
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const consultarEnviarDinamicaMiembroWpApi = async (userId) => {
  try {
    const url = `userswp/miembros/consultar`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: { user_id: userId },
      time: 45000,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const listarBeneficiariosMiembroWpApi = async (userId) => {
  try {
    const url = `userswp/miembros/beneficiarios`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: { user_id: userId },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const listarCitasMiembroWpApi = async (userId) => {
  try {
    const url = `userswp/miembros/citas`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: { user_id: userId },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const registrarEnvioDinamicaExitosoMiembroWpApi = async (userId) => {
  try {
    const url = `userswp/miembros/dinamica/registrar`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: { user_id: userId },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export { buscarMiembrosWpApi, listarNivelesMiembrosWpApi, consultarEnviarDinamicaMiembroWpApi, 
  listarBeneficiariosMiembroWpApi, listarCitasMiembroWpApi, registrarEnvioDinamicaExitosoMiembroWpApi };
